import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import c from "../../../../../hooks/useBalanceAccounts.js";
import i from "../../../../internal/DataOverviewContainer/DataOverviewContainer.js";
import { PayoutsOverview as u } from "../PayoutsOverview/PayoutsOverview.js";
import { BASE_CLASS as s } from "./constants.js";
function f({ ...o }) {
  const { balanceAccounts: t, isBalanceAccountIdWrong: a, isFetching: e, error: n } = c(o.balanceAccountId);
  return /* @__PURE__ */ r(
    i,
    {
      balanceAccountsError: n,
      className: s,
      errorMessage: "weCouldNotLoadThePayoutsOverview",
      isBalanceAccountIdWrong: a,
      onContactSupport: o.onContactSupport,
      children: /* @__PURE__ */ r(u, { ...o, balanceAccounts: t, isLoadingBalanceAccount: e })
    }
  );
}
export {
  f as default
};
